import SpriteSymbol from "../../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "filter",
  "use": "filter-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" id=\"filter\">\n\t<g stroke=\"currentColor\" stroke-width=\"2\">\n\t\t<path d=\"M2.866 6.543h18.605M5.494 12.073h13.349M9.173 17.603h5.991\" />\n\t</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol